import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, take } from 'rxjs';
import { PolicyService } from 'src/app/modules/policy/policy.service';
import { BasicModalComponent } from 'src/app/modules/shared/components/basic-modal/basic-modal.component';
import { UNDERSTOOD_BUTTON } from 'src/app/modules/shared/components/basic-modal/basic-modal.constants';
import { EPolicyCompany } from 'src/app/modules/shared/models/policy.model';
import { LoggerService } from 'src/app/services/logger.service';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { CANCEL_OPERATIONS, ICancelDocument, IDocument } from '../../athora.constants';
import { AthoraService } from '../../athora.service';

@Component({
  selector: 'app-document-download',
  templateUrl: './document-download.component.html',
  styleUrl: './document-download.component.scss',
})
export class DocumentDownloadComponent implements OnInit, OnChanges, OnDestroy {

  @Input() documents: IDocument[] | ICancelDocument[];
  @Input() errorRetrievingDocs: boolean;
  @Input() isAlreadySubmitted: boolean;
  destroy$ = new Subject<boolean>();

  constructor(
    private _athoraService: AthoraService,
    private _policyService: PolicyService,
    private readonly _dialog: MatDialog
  ) { }

  ngOnInit(): void {
    if (!this.isCancelOperation && CommonUtils.isVoidObj(this.documents)) {
      this.retrieveDocuments();
    }
  }

  ngOnChanges(simpleChanges: SimpleChanges): void {
    if (simpleChanges['documents'] && simpleChanges['documents'].currentValue) {
      this.documents = (this.documents || [])
        .map((doc) => ({
          ...doc,
          isDownloaded: doc?.isDownloaded || doc?.userDownloaded,
        }))
        .filter((doc) => doc.providedFromCompany);
    }
  }

  openInfoModal(): void {
    // TODO MODALE con text: ISV_DOWNLOAD_INFO
    // TODO MODALE
    /* if (this.isISVPolicy) {
      this._modalRef = this._modalService.open(BasicModalComponent, {
        data: {
          text: ISV_DOWNLOAD_INFO,
          buttons: [
            UNDERSTOOD_BUTTON
          ]
        }
      });
    } */

  }

  openIsvInfoModal(): void {
    this._dialog.open(BasicModalComponent, {
      data: {
        title: "Attenzione!",
        text: "",
        modalSize: 'modal-box-small align-items-center text-center',
        buttons: [
          UNDERSTOOD_BUTTON
        ]
      },
      disableClose: true
    })
      .afterClosed()
      .pipe(take(1))
      .subscribe(outcome => {
      })
  }

  retrieveDocuments(): void {
    LoggerService.logInfo(this.constructor.name, 'retrieveDocuments');
    this._policyService.retrieveDocuments();
  }

  retrieveDocumentInfo(document: IDocument): void {
    LoggerService.logInfo(this.constructor.name, 'retrieveDocumentInfo', { document });
    this._policyService.retrieveDocumentInfo(document);
  }

  downloadDocRetry(): void {
    LoggerService.logInfo(this.constructor.name, 'downloadDocRetry', { document });
    this._athoraService.downloadDocRetry(true);
  }

  get policyCompany(): string {
    return this._policyService.companyId;
  }

  get isISVPolicy(): boolean {
    return this.policyCompany === EPolicyCompany.ISV;
  }

  get isCancelOperation(): boolean {
    return CANCEL_OPERATIONS.includes(this._policyService.operationId);
  }

  get showRetrieveDocsButton(): boolean {
    return this.isCancelOperation && this.errorRetrievingDocs;
  }

  get isAnnulloAppendice(): boolean {
    return this._policyService.operationId === '_ANAPP';
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
